// extracted by mini-css-extract-plugin
export default {"root":"HomeLayout-module--root--2s_Jg","inner":"HomeLayout-module--inner--2xGcv"};